export default {
  showLoader({ commit }) {
    commit('setLoader', true)
  },
  hideLoader({ commit }) {
    commit('setLoader', false)
  }
}
